import app from '../../../app.jsx'

const signupExistingUser = async (userTeam, password) => {
  const {
    availableTeams,
    activeTeam,
    teamsUserIsInvitedTo
  } = await app.authentication.login({
    email: userTeam.email,
    password,
    isSignupFlow: true
  })

  /*
   In signup flow for an existig user, When there is not availableTeams (and therefore activeTeam is null)
   (for example when their previous team's subscription has been canceled),
   the activeTeam should be the team that user has invitation for.
   for more information take look at this ticket: https://rodeodev.atlassian.net/browse/SUP-1280
  */
  if (availableTeams.length === 0) {
    return {
      availableTeams,
      activeTeam: teamsUserIsInvitedTo.find(team => team.id === userTeam.teamId)
    }
  }

  return { availableTeams, activeTeam }
}

export { signupExistingUser }
